import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	OnInit,
	Output,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import {
	map,
	take,
	tap,
} from 'rxjs/operators';

import { timer } from 'rxjs';

import { SplittedInputMode } from 'ib/internetbank-core/ib-components/splitted-input/splitted-input-mode';


@Component({
	selector: 'app-registration-product-confirmation-code',
	templateUrl: './registration-product-confirmation-code.component.html',
	styleUrls: ['./registration-product-confirmation-code.component.less'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class RegistrationProductConfirmationCodeComponent implements OnInit {

	@Output()
	public confirmationCode = new EventEmitter<string>();

	@Output()
	public resetTimer = new EventEmitter();

	public smsCodeInputMode: SplittedInputMode = SplittedInputMode.DIGITS;
	public smsCode: string;

	public confirmationCodeControl = new UntypedFormControl();

	public time = 10;
	public countDown$ = this.createCountDown();

	constructor() { }


	public createCountDown() {
		return timer(0, 1000).pipe(
			map((value: number) => this.time - value),
			take(this.time + 1),
		);
	}

	public ngOnInit(): void {
		this.confirmationCodeControl.valueChanges
			.pipe(
				tap((value: string) => {
					this.confirmationCode.emit(value);
				}),
			)
			.subscribe();
	}

	public restartTimer() {
		this.countDown$ = this.createCountDown();
		this.confirmationCodeControl.setValue(null);
		this.resetTimer.emit();
	}

}
